import angular from "angular";

angular
    .module('app')
    .component('categoryForm', {
        template: require('./category-form.html'),
        controller: ['$http', '$uibModal', 'ErrorResponseParser', 'Notifier', '$scope', 'Upload', '$timeout', controller],
        bindings: {
            category: '<',
        }
    });

function controller($http, $uibModal, ErrorResponseParser, Notifier, $scope, Upload, $timeout) {


    let $ctrl = this;

    $ctrl.id = null;
    $ctrl.title = null;

    $ctrl.$onInit = function () {
        if ($ctrl.category) {
            $ctrl.categoryId = $ctrl.category.id;
            $ctrl.title = $ctrl.category.title;
            $ctrl.image_path = $ctrl.category.image;
        }
    };

    $ctrl.submit = function () {

        $ctrl.loading = true;

        if ($ctrl.category) {
            $http
                .post(`/admin/categories/${$ctrl.categoryId}`, {
                    title: $ctrl.title,
                    _method: 'PUT'
                })
                .then(
                    function (response) {
                        Notifier.success('Saved');
                    },
                    function (error) {
                        Notifier.error('Error');
                        $ctrl.loading = false;
                    }
                );
        } else {
            $http
                .post('/admin/categories', {title: $ctrl.title})
                .then(
                    function (response) {
                        Notifier.success('Saved');
                        $timeout(function () {
                            window.location = '/admin/categories/';
                        }, 4);
                    },
                    function (error) {
                        Notifier.error('Error');
                        $ctrl.loading = false;
                    }
                );
        }

    };

}
